import { render, staticRenderFns } from "./DPostContentEditor.vue?vue&type=template&id=395335a6&"
import script from "./DPostContentEditor.vue?vue&type=script&lang=js&"
export * from "./DPostContentEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports